import { Theme } from "@material-ui/core"
import makeStyles from "@material-ui/core/styles/makeStyles"
import React, { Fragment, useContext, useMemo } from "react"
import Grid from "@material-ui/core/Grid"
import { AppContext } from "../Home/context"
import TagItem from "./TagItem"
import ArticleTypeAdd from "./ArticleTypeAdd"
import { BeautyCalendarTab, Tag } from "Types/app"
import { IVariable } from "Types/table"
import { useInputChange } from "Hooks/basic"
import { useOldTable as useTable } from "Hooks/table"
import { tableInitialVariables } from "Methods/table"
import { InitialModal } from "Methods/modal"
import { checkUserPrivilege } from "Methods/privilege"
import { generateMutation, generateQuery } from "Methods/query"
import cnchar from "cnchar"

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4),
        width: "100%",
        overflow: "hidden",
    },
    text: {
        marginLeft: theme.spacing(4),
    },
    info: {
        padding: "10px 20px",
        color: "#666666",
        fontSize: 14,
    },
}))
const initVariables = {
    ...tableInitialVariables,
    limit: 1000,
}
interface ComponentProps {
    tab: BeautyCalendarTab,
    index: number,
    privilegeMap: any,
}

const TabPanel = (props: ComponentProps) => {
    const { tab, privilegeMap } = props
    const { value, where } = tab
    const classes = useStyles()
    const { handleChangeModal, user } = useContext(AppContext)
    const {
        department: {type_name = ''} = {},
        role: { role_name = '' } = {},
    } = user || {}
    const privilege = checkUserPrivilege(privilegeMap, value)
    const addVariables: IVariable[] = useMemo(() => {
        if (value === "beauty_article_type") {
            return [
                { name: "name", type: "String"},
                { name: "type_name", type: "String"},
                { name: "color_code", type: "String"},
                { name: "hidden", type: "Boolean"},
            ]
        }
        return [
            { name: "name", type: "String"},
        ]
    }, [value])
    const { data, onRowAdd, onRowUpdate } = useTable({
        tableName: value,
        initVariables: {
            ...initVariables,
            where: where ? where : initVariables.where
        },
        getQuery: generateQuery(value),
        addMutation: generateMutation("insert", value, addVariables),
        updateMutation: generateMutation("update", value, [
            { name: "name", type: "String"},
            { name: "hidden", type: "Boolean"},
            { name: "id", type: "Int"},
        ]),
        delMutation: generateMutation("delete", value, [
            { name: "id", type: "Int"},
        ]),
        field: ["id", "name", "hidden"],
    })
    const { text: name, handleChange, clearText } = useInputChange("")
    const handleDelete = (tag: Tag) => {
        handleChangeModal({
            show: true,
            type: "warning",
            title: `确定删除 ${tag.name}？`,
            showCancel: true,
            onConfirm: async () => {
                await onRowUpdate({
                    ...tag,
                    hidden: true,
                })
                handleChangeModal({
                    show: true,
                    type: "success",
                    title: "已删除！",
                    timeout: 800,
                    onConfirm: () => {
                        handleChangeModal(InitialModal)
                    },
                })
            },
            onCancel: () => {
                handleChangeModal(InitialModal)
            },
        })
    }
    return (
        <Fragment>
            <Grid container className={classes.root} justify="flex-start">
                {data.map((tag: Tag) => (
                    <Grid key={tag.id} item>
                        <TagItem value={value} tag={tag} onDelete={handleDelete} canDelete={privilege.update && ((['beauty'].indexOf(type_name) >= 0 && ['side_editor'].includes(role_name)) || (type_name === 'marketing' && role_name === 'user')  || (type_name === 'newmedia' && role_name === 'side_editor'))}/>
                    </Grid>
                ))}
                { privilege.insert
                && (
                    (['beauty'].indexOf(type_name) >= 0 && ['side_editor'].includes(role_name))
                    || (type_name === 'marketing' && role_name === 'user')
                    // 电商内容 编辑部编辑
                    || (type_name === 'newmedia' && role_name === 'side_editor')
                ) ? (
                    <Grid item>
                        { value === "beauty_article_type" && <ArticleTypeAdd onRowAdd={onRowAdd}/> }
                    </Grid>
                ) : null }
            </Grid>
        </Fragment>
    )
}

export default TabPanel
